import { React, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DeleteIcon from '@material-ui/icons/Delete';
import Modal from '@material-ui/core/Modal';
import db from "../firebase";





const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  paper: {

    margin: '0  auto',
    position: 'relative',
    top: '27%',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  btn: {
    margin: '1.5rem',
    border: '3px solid black',
    borderRadius: '12px',
    background: 'transparent',
    outline: 'none'
  },
  text: {
    border: '3px solid black',
    borderRadius: '12px',
    outline: 'none'
  }
}));

export default function Newtodoitem(props) {


  const editchanges = () => {
    console.log(input);

    handleClose();
    db.collection('todos').doc(props.item.id).set({
      todo: input

    }, { merge: true });
  };

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [input, setinput] = useState('');



  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (

    <>

      <Modal
        open={open}
        onClose={handleClose}

      >
        <div className={classes.paper}>
          <input type="text" className={classes.text} onChange={event => setinput(event.target.value)} />
          <button disabled={!input} className={classes.btn} onClick={editchanges}> save </button>
        </div>
      </Modal>

      <List>
        <ListItem>


          <ListItemText primary={props.item.todo} />
          <button className={classes.btn} onClick={handleOpen}>edit</button>
          <DeleteIcon onClick={event => { db.collection('todos').doc(props.item.id).delete() }} />

        </ListItem>


      </List>

    </>
  );
}
